export const GridPaddingX = ['sp_8', 'sp_12', '36px', 'sp_48'];

export const GridGutter = ['sp_8', 'sp_12', null, 'sp_16'];
